import { withStyles } from '@material-ui/core/styles'
import LinearProgress from '@material-ui/core/LinearProgress'

export const useStyles = makeStyles((theme) => ({
  formContainer: {
    padding: 0,
  },
  sectionTitle: {
    padding: '5px 10px',
  },
  petitionCounter: {
    color: theme.palette.primary.main,
  },
}))
export const StyledLinearProgress = withStyles({
  root: {
    height: '40px',
    borderRadius: '5px',
    marginBottom: '20px',
  },
  bar: {
    height: '40px',
  },
  colorPrimary: {
    backgroundColor: 'white',
  },
  barColorPrimary: {
    backgroundColor: '#00a8d7',
  },
})(LinearProgress)
